import {
  createComponentExtension,
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { notMyReportRouteRef, rootRouteRef } from './routes';

export const slackNudgesPlugin = createPlugin({
  id: 'slack-nudges',
  routes: {
    root: rootRouteRef,
    notMyReport: notMyReportRouteRef,
  },
});

export const SlackNudgesPage = slackNudgesPlugin.provide(
  createRoutableExtension({
    name: 'SlackNudgesPage',
    component: () =>
      import('./components/SlackNudgesPage/SlackNudgesPage').then(
        m => m.SlackNudgesPage,
      ),
    mountPoint: rootRouteRef,
  }),
);

export const EntityRosterVerificationBanner = slackNudgesPlugin.provide(
  createComponentExtension({
    name: 'EntityRosterVerificationBanner',
    component: {
      lazy: () =>
        import('./components/EntityRosterVerificationBanner/EntityRosterVerificationBanner').then(
          m => m.EntityRosterVerificationBanner,
        ),
    },
  }),
);

export const NotMyReportPage = slackNudgesPlugin.provide(
  createRoutableExtension({
    name: 'NotMyReportPage',
    component: () =>
      import('./components/NotMyReportPage/NotMyReportPage').then(
        m => m.NotMyReportPage,
      ),
    mountPoint: notMyReportRouteRef,
  }),
);
